import { render, staticRenderFns } from "./facebookRating.vue?vue&type=template&id=950e5c8c&"
import script from "./facebookRating.vue?vue&type=script&lang=js&"
export * from "./facebookRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports